import * as React from 'react'

import { styled } from '~/styled'

const StyledRow = styled('tr', {
  base: ['bg-[unset]']
})

export const TableRow = React.forwardRef<
  HTMLTableRowElement,
  React.ComponentProps<typeof StyledRow>
>((props, ref) => <StyledRow {...props} ref={ref} />)

TableRow.displayName = 'TableRow'
